import{heightPropDefs as o}from"../props/height.props.js";import{widthPropDefs as e}from"../props/width.props.js";const p={loading:{type:"boolean",default:!0},...e,...o};export{p as skeletonPropDefs};
//# sourceMappingURL=skeleton.props.js.map
